import { withJsonFormsControlProps } from "@jsonforms/react";
import KeywordChips from "./KeywordChips";

function KeywordChipsRenderer({ data, handleChange, path, enabled, label }) {
  const keywords = data || [];

  const handleKeywordsChange = (newKeywords) => {
    handleChange(path, newKeywords);
  };

  return (
    <KeywordChips
      label={label}
      keywords={keywords}
      onChange={handleKeywordsChange}
      disabled={!enabled}
    />
  );
}

const KeywordChipsRendererWithProps =
  withJsonFormsControlProps(KeywordChipsRenderer);

export default KeywordChipsRendererWithProps;
